import React from 'react';

const PictureContentLeft = ({
  bgColor,
  srcImg,
  title,
  titleColor,
  content,
  contentColor,
  btnContent,
}) => {
  return (
    <div style={{ backgroundColor: bgColor }} className={`w-full py-5 my-2 px-[2vw] md:px-[1vw]`}>
      <div className="grid md:grid-cols-3 ">
        <div className="col-span-1 ml-[8vw] md:ml-14 lg:ml-[9vw] md:pt-10">
          <img className={`max-h-[660px] object-contain justify-self-start`} src={srcImg} alt="/" />
        </div>
        <div className="flex flex-col justify-center col-span-2 md:text-left py-5 mx-[8vw] md:mr-16 lg:mr-[10vw] md:ml-0">
          <h1
            style={{ color: titleColor }}
            className="text-2xl md:text-3xl lg:text-[35px] font-bold md:ml-10 text-shadow-sm"
          >
            {title}
          </h1>
          <p
            style={{ color: contentColor }}
            className="py-6 text-md lg:text-[18px] md:ml-10 max-w-6xl"
          >
            {content}
          </p>
          <div className="ml-0 md:ml-10 py-2">{btnContent}</div>
        </div>
      </div>
    </div>
  );
};

export { PictureContentLeft };
